import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=a1ea125e&"
import script from "./studentInfo.vue?vue&type=script&lang=js&"
export * from "./studentInfo.vue?vue&type=script&lang=js&"
import style0 from "./studentInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports